import { memo } from 'react';
import styled, { css } from 'styled-components';
import { colors, typography, spacing, borderRadius } from '@izettle/otto';
import { InputBase } from '../input-base/components.js';
import { SemanticState } from '../../enumerations/semantic-state.js';

const mixinInput = css`
  caret-color: ${_ref => {
  let {
    disabled,
    semanticState,
    isFocused
  } = _ref;
  if (disabled) {
    return;
  }
  const semanticColors = {
    [SemanticState.Warning]: isFocused ? colors.icon.warning.large : colors.text.warning,
    [SemanticState.Error]: isFocused ? colors.icon.error.large : colors.text.error,
    [SemanticState.Success]: isFocused ? colors.action.secondary.text.default : colors.text.success,
    [SemanticState.Default]: isFocused ? colors.action.secondary.text.default : colors.text.default
  };
  const semanticColorsKey = semanticState ?? SemanticState.Default;
  return semanticColors[semanticColorsKey];
}};
`;
const InputMemoized = /*#__PURE__*/memo(styled.input.withConfig({
  displayName: "styles__InputMemoized",
  componentId: "zettle__sc-lm4axe-0"
})(["&&{background-color:unset;height:unset;width:unset;", " margin:0 ", ";flex:1;border-radius:", ";border:none;outline:none;padding:0;min-width:0;transition:color 0.1s cubic-bezier(0.25,0.1,0.25,1);&:disabled{background:none;cursor:not-allowed;color:", ";-webkit-text-fill-color:", ";opacity:1;}:required{box-shadow:none;}", " &:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus{background-color:", " !important;box-shadow:none;-webkit-box-shadow:none;transition:background-color 5000s ease-in-out 0s;}}"], typography.regular, spacing.small, borderRadius.large, colors.text.disabled, colors.text.disabled, mixinInput, colors.background.default));
const InputBaseStyled = /*#__PURE__*/styled(InputBase).withConfig({
  displayName: "styles__InputBaseStyled",
  componentId: "zettle__sc-lm4axe-1"
})(["cursor:", ";"], _ref2 => {
  let {
    isDisabled
  } = _ref2;
  return isDisabled ? "not-allowed" : "text";
});

export { InputBaseStyled, InputMemoized };
//# sourceMappingURL=styles.js.map
